import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import RequestV2SubmissionProgressAndOutputs from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputs';
import RequestV2SubmissionProgressAndOutputsTabState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionProgressAndOutputsTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export default class RequestV2SubmissionProgressAndOutputsTabView extends BufferTabView<RequestV2SubmissionProgressAndOutputsTabState> {
  render(): this {
    const requestV2SubmissionFileState = this.model.getRequestV2SubmissionFileState();
    const props = {
      requestV2SubmissionId: requestV2SubmissionFileState.id,
      folder: requestV2SubmissionFileState.model().folder(),
    };
    renderToDOM(
      <div className="react-tab-container" style={{padding: 0}}>
        <RequestV2SubmissionProgressAndOutputs {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<RequestV2SubmissionProgressAndOutputsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RequestV2SubmissionProgressAndOutputsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
